(() => {
  if (window.PuaintaHomeReveal) return;

  const markerClass = 'puainta-home-v2-reveal-enabled';
  const sectionSelector = '.puainta-home-v2__section';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer = null;
  let initialized = false;

  const collectSections = (root = document) => {
    const sections = [];

    if (root instanceof Element && root.matches(sectionSelector)) {
      sections.push(root);
    }

    root.querySelectorAll?.(sectionSelector).forEach((section) => sections.push(section));
    return sections;
  };

  const reveal = (section) => {
    section.classList.add('is-revealed');
    observer?.unobserve(section);
  };

  const isInInitialViewport = (section) => {
    const rect = section.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  };

  const prepare = (root = document) => {
    collectSections(root).forEach((section) => {
      if (section.dataset.puaintaRevealReady === 'true') return;
      section.dataset.puaintaRevealReady = 'true';

      if (reducedMotion.matches || !observer || isInInitialViewport(section)) {
        reveal(section);
        return;
      }

      observer.observe(section);
    });
  };

  const revealAll = () => {
    collectSections(document).forEach(reveal);
  };

  const initialize = () => {
    if (initialized) return;
    initialized = true;

    if (!reducedMotion.matches && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            reveal(entry.target);
          });
        },
        { threshold: 0.15 }
      );
    }

    prepare(document);
  };

  try {
    document.documentElement.classList.add(markerClass);

    window.PuaintaHomeReveal = {
      prepare,
      revealAll,
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => {
      window.requestAnimationFrame(() => prepare(event.target));
    });

    reducedMotion.addEventListener?.('change', (event) => {
      if (!event.matches) return;
      observer?.disconnect();
      revealAll();
    });
  } catch (error) {
    document.documentElement.classList.remove(markerClass);
    console.error('[Puainta] Section reveal initialization failed.', error);
  }
})();
